export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14518.b2b164ac.jpg";